export default "__VITE_ASSET__B7HRpAHn__"